import * as CapitalMuiTheme_Theme_components_surfaces_MuiAccordion from "./MuiAccordion.js";
import * as CapitalMuiTheme_Theme_components_surfaces_MuiCard from "./MuiCard.js";
import * as CapitalMuiTheme_Theme_components_surfaces_MuiPaper from "./MuiPaper.js";
const surfaces = {
  ...CapitalMuiTheme_Theme_components_surfaces_MuiAccordion,
  ...CapitalMuiTheme_Theme_components_surfaces_MuiCard,
  ...CapitalMuiTheme_Theme_components_surfaces_MuiPaper
};
export {
  surfaces
};
//# sourceMappingURL=index.js.map
